<template>
  <div class="service-master-pump-failure-alarm">
    <p>
      {{ $t('messages.alarms.serviceMasterPumpFailureAlarm.description') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
    />

    <div class="g-alarm-handler__row">
      <!-- <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>{{ $t('messages.alarms.serviceMasterPumpFailureAlarm.suggestion') }}</p> -->
      <p class="g-alarm-handler__highlight g-alarm-handler__highlight--yellow">
        <strong>
          {{ $t('messages.alarms.attention') }}:
        </strong>
        {{ $t('messages.alarms.serviceMasterPumpFailureAlarm.attention') }}
      </p>

      <div class="g-alarm-handler__row g-text g-text--center">
        <selective-survey-button :list="alarmData.list" />
      </div>

      <p>{{ $t('messages.alarms.serviceMasterPumpFailureAlarm.suggestion2') }}</p>

      <ol>
        <li>{{ $t('messages.alarms.serviceMasterPumpFailureAlarm.label1') }}</li>
        <li>{{ $t('messages.alarms.serviceMasterPumpFailureAlarm.label2') }}</li>
        <li>{{ $t('messages.alarms.serviceMasterPumpFailureAlarm.label3') }}</li>
        <li>{{ $t('messages.alarms.serviceMasterPumpFailureAlarm.label4') }}</li>
        <li>{{ $t('messages.alarms.serviceMasterPumpFailureAlarm.label5') }}</li>
        <li>{{ $t('messages.alarms.serviceMasterPumpFailureAlarm.label6') }}</li>
      </ol>
    </div>
  </div>
</template>


<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'
import ServiceSelectiveSurveyButton from '@/components/elements/ServiceSelectiveSurveyButton'

export default {
  name: 'ServiceMasterPumpFailureAlarm',
  components: {
    'selective-survey-button': ServiceSelectiveSurveyButton
  },
  mixins: [ServiceAlarm]
}
</script>
